"use client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../components/ui/table";

const apiUrl = process.env.REACT_APP_API_URL;

export default function SpecialOccasionMenusTable() {
  const [specialOccasionMenus, setSpecialOccasionMenus] = useState<any[]>([]);
  const navigate = useNavigate();
  const handleRowClick = (menu: any) => {
    navigate("/update-special-occasion-menu", { state: { menu } });
  };

  const fetchSpecialOccasionMenus = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/special_occasion_menus`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
      });

      const result = await response.json();

      if (result.success) {
        setSpecialOccasionMenus(Array.isArray(result.specialOccasionMenus) ? result.specialOccasionMenus : []);
      } else {
        setSpecialOccasionMenus([]);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      setSpecialOccasionMenus([]);
      console.error("Failed to fetch special occasion menus:", error);
    }
  }

  useEffect(() => {
    fetchSpecialOccasionMenus();
  }, []);

  const formatDateTime = (dateString: string) => {
    const localDateString = dateString.replace(/Z$/, '');
    const date = new Date(localDateString); 

    const datePart = date.toLocaleDateString('en-AU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    return `${datePart}`;
  };

  return (
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-2 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Event
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-2 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Menu Type
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-2 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Start Date
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-2 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    End Date
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-2 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Date Added
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {specialOccasionMenus.map((menu) => (
            <TableRow
              key={menu.menu_id}
              className="cursor-pointer hover:bg-[#ffffa3]"
              onClick={() => handleRowClick(menu)}
            >
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-white/90 whitespace-normal">
                <span>{menu.event_name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{menu.meal_type}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{formatDateTime(menu.start_date)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{formatDateTime(menu.end_date)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{formatDateTime(menu.created_at)}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
